module.exports = __webpack_public_path__ + "static/media/Tackling_3.8422835a.png";